import { connect } from 'react-redux';
import Navigation from '../shared/nav/Navigation';
import { getMenuItems } from '../redux/selectors/navigation';
import { checkPermission } from '../utils/ProfileHelpers';

import { withRouter } from 'react-router-dom';

const mapStateToProps = (state) => {
  return {
    paths: state.app.paths || {},
    teams: state.profile.teams,
    team: state.profile.team,
    tabs: getMenuItems(state.profile, state.app.paths || {}, state.profile.billingPermissions, checkPermission),
  };
};

const mapDispatchToProps = (dispatch) => ({});

export default withRouter(connect(mapStateToProps, mapDispatchToProps, null, { forwardRef: true })(Navigation));
